export default __webpack_public_path__ + "media/images/home/slide_go_sm-eea591071deacd6938469204ead85e2c.jpg";